module.exports = __webpack_public_path__ + "img/case1.560f9936.png";